import React from 'react';

const NotFound = () => {
    return (
        <div className="alert alert-danger">
            <h1>Page not found</h1>
            <h3>404 Error!!!</h3>
        </div>
    );
};

export default NotFound;